import { colors, fontSizes } from '../../../consts'
import { styled } from '@mui/system'

export const AppExclusiveOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  position: 'absolute',
  left: 0,
  bottom: 0,
  right: 0,
  top:45,
  height: '95%',
  background: `linear-gradient(${colors.white}0, ${colors.white} 80%) `,
  zIndex: 99,
  borderRadius: 12,
  border: `solid 0.5px ${colors.lightestGrey}`,
  borderTop: 'none',
}))

export const AppExclusiveCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  paddingTop: 10,
  width: '100%',
  maxHeight: '45%',
  background: colors.offWhite,
  borderRadius: `0 0 12px 12px`,
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '50%',
  },
  '& .infoCon': {
    margin: theme.spacing(1, 0),
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
    '& .titleCon': {
      display: 'flex',
      alignItems: 'center',
      '& img': {
        width: 20,
        margin: theme.spacing(0, 2),
        borderRadius: 5,
      },
      '& .title': {
        fontSize: fontSizes.semiLarge,
        color: colors.text,
        fontWeight: 'bold',
        margin: 0,
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.small,
        },
      },
    },
  },
  '& p': {
    fontSize: fontSizes.small,
    color: colors.text,
    fontWeight: 'bold',
    margin: theme.spacing(1, 1),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
    },
  },
  '& a': {
    margin: theme.spacing(1, 0),
    display: 'inline-block',
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    fontSize: fontSizes.xSmall,
    fontWeight: 'bold',
    background: colors.yellow,
    color: colors.text,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}))

export const QRCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    width: 120
  },
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  '& .scanText': {
    margin: `2px 5px`,
    fontSize: fontSizes.xSmall,
    color: colors.text,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

// LOGIN //
export const LoginQuestionCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  padding: `10px 0`,
  width: '100%',
  maxHeight: '40%',
  background: colors.gray.gray90,
  borderRadius: 12,
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .infoCon': {
    margin: theme.spacing(1, 0),
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
    '& .title': {
      fontSize: fontSizes.semiLarge,
      color: colors.white,
      fontWeight: 'bold',
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
    '& p': {
      fontSize: fontSizes.small,
      color: colors.white,
      fontWeight: 'bold',
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
  '& p': {
    fontSize: fontSizes.small,
    color: colors.text,
    fontWeight: 'bold',
    margin: theme.spacing(1, 1),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
    },
  },
  '& a': {
    margin: theme.spacing(2, 0),
    display: 'inline-block',
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    fontSize: fontSizes.small,
    fontWeight: 'bold',
    background: colors.yellow,
    color: colors.text,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}))
